"use client"

import { useMolecule } from "bunshi/react"
import { getFeaturedBlockchain } from "../featured-blockchain/get-featured-blockchain"
import { BlockchainFiltersMoleculeReatom as BlockchainFiltersMolecule } from "./blockchain-filters-molecule.reatom"

export function useSelectedOrFeaturedBlockchain() {
  const { selectedBlockchain } = useMolecule(BlockchainFiltersMolecule)
  const selectedBlockchainValue = selectedBlockchain()

  const blockchainToUse =
    selectedBlockchainValue === "ALL"
      ? getFeaturedBlockchain()
      : selectedBlockchainValue

  return {
    selectedBlockchain: blockchainToUse,
  }
}
